(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('resumoStand', ResumoStand);

  function ResumoStand() {
    return {
      restrict: 'E',
      controller: 'ResumoStandCtrl',
      scope: {
        data: '<'
      },
      templateUrl: 'views/painel_propriedade/_resumo_stand.html'
    };
  }
}());
